<div class="filters">
  <div class="filter">
    <label>Vorname</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        pInputText
        type="text"
        placeholder="Suchen"
        [(ngModel)]="firstName"
        (keydown.enter)="filter()"
        (ngModelChange)="onAnyChange()"
      />
    </p-iconField>
  </div>
  <div class="filter">
    <label>Nachname</label>
    <p-iconField iconPosition="left">
      <p-inputIcon styleClass="pi pi-search" />
      <input
        pInputText
        type="text"
        placeholder="Suchen"
        [(ngModel)]="lastName"
        (keydown.enter)="filter()"
        (ngModelChange)="onAnyChange()"
      />
    </p-iconField>
  </div>
  <div class="filter">
    <label>Kunde</label>
    <p-dropdown
      [options]="customerOptions"
      [(ngModel)]="selectedCustomerId"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      [showClear]="true"
      placeholder="Alle"
      (keydown.enter)="filter()"
      (ngModelChange)="onAnyChange()"
      [style]="{ width: '240px' }"
    ></p-dropdown>
  </div>
  <div class="filter-actions">
    <app-button (click)="filter()" label="Filtern" type="primary-button" />
    <app-button
      (click)="clearFilter()"
      label="Filter zurücksetzen"
      type="secondary-button"
      [disabled]="!showClearButton"
    />
  </div>
</div>
